import { schema } from "normalizr"

export default new schema.Entity("amountUnits", {}, { idAttribute: "amountUnitId" })
